<template>
  <div class="screen-wrap">
    <div class="condition-item" :style="{height:seeMore?'auto':'60px'}">
      <span class="label">行业类型：</span>
      <span class="see-more" @click="()=>{seeMore=!seeMore}">
        {{seeMore?'收起':'更多'}}
        <span :class="['icons',{'rotate':seeMore}]">&#xe607;</span>
      </span>
      <div class="tags">
        <span
          v-for="item in list"
          @click="screenTag(item)"
          :style="{color:selectTag==item.id?'#8899f2':''}"
          :key="item.id"
        >{{item.name}}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      seeMore: false,
      selectTag: -1,
      list: []
    }
  },
  created() {
    this.getIndustry()
  },

  methods: {
    // 获取分类列表
    getIndustry() {
      this.$jsonp(
        `http://h5.vedamobi.com/index.php/api/api/get_industry?page=${this.page}&title=${this.title}`,
        {},
        (error, data) => {
          if (data && data.code === 200) {
            this.total = data.total
            this.list = data.data
          } else {
            this.$message.error(`${error},${data.msg}`)
          }
        }
      )
    },
    screenTag(item) {
      if (this.selectTag === item.id) {
        this.selectTag = -1
        this.$emit('select', false)
      } else {
        this.selectTag = item.id
        this.$emit('select', item)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.screen-wrap {
  width: 100%;
  background-color: #fff;
  border-radius: 6px;
  .condition-item {
    line-height: 60px;
    border-bottom: 1px solid #eee;
    overflow: hidden;
    transition: height 0.5s;
  }
  .label {
    float: left;
    margin: 0 10px;
    color: #888;
    font-size: 14px;
    display: block;
    height: 60px;
    line-height: 60px;
  }
  .tags {
    margin: 0 100px;
    span {
      display: inline-block;
      margin-right: 48px;
      font-size: 14px;
      cursor: pointer;
    }
  }
  .see-more {
    cursor: pointer;
    float: right;
    margin-right: 10px;
    line-height: 60px;
    color: #888;
    user-select: none;
    .icons {
      display: inline-block;
      font-family: 'iconfont';
      transition: transform 0.5s;
      transform: rotate(0deg);
    }
    .rotate {
      transform: rotate(180deg);
    }
  }
}
</style>